<template>
  <div>
    <v-dialog v-model="message.status" fullscreen>
      <v-alert
        class="mx-auto my-12"
        max-width="374"
        v-model="message.status"
        dismissible
        prominent
        shaped
        :type="message.color"
      >{{ message.text }}
      </v-alert>
    </v-dialog>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            v-model="search"
            label="جستجو کاربر مورد نظر براساس تمام فیلدها از سرور"
            :prepend-icon="mdiAccountSearchOutline"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="4" xl="4">
          <v-btn @click="searchUser">
            جستجو...
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="users"
            class="elevation-1"
            item-key="id"
          >
            <template v-slot:item.roles="{ item }">
              <v-chip
                v-for="role in item.roles"
                dark
                outlined
                color="success"
                class="ma-1"
                close
                @click:close="deleteRoleFromUser(item,role.name)"
              >
                {{ role.name }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                dark
                outlined
                color="primary"
                class="ma-1"
                close
                @click="setRoleToUser(item)"
              >
                تنظیم نقش "{{ $route.params.role }}"
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>


</template>

<script>
import {mdiAccountSearchOutline} from '@mdi/js'
import axios from "@axios";
import router from "@/router";
import baseConfig from "@/../baseConfig";

export default {
  name: 'Assign',
  data() {
    return {
      mdiAccountSearchOutline,
      loading: false,
      search: '',
      message: {
        status: false,
        text: "success operation",
        color: "success"
      },
      headers: [
        {text: 'نام', value: 'first_name'},
        {text: 'نام خانودگی', value: 'last_name'},
        {text: 'شماره تماس', value: 'mobile'},
        {text: 'آدرس ایمیل', value: 'email'},
        {text: 'نقش / نقش ها', value: 'roles'},
        {text: '', value: 'actions'},
      ],
      users: [],
    }
  },
  beforeCreate() {
    if (localStorage.getItem("accessToken") === "undefined" || localStorage.getItem("accessToken") === undefined || localStorage.getItem("accessToken") === "null" || localStorage.getItem("accessToken") === null || localStorage.getItem("accessToken") === "") {
      router.push('/login')
    }
  },
  async mounted() {
    await axios.get(baseConfig.basUrlRaw+'api/frontUser/permissions/users').then(r => {
      this.users = r.data.data
    })
  },
  methods: {
    async searchUser() {
      await axios.get(baseConfig.basUrlRaw+'api/frontUser/permissions/users/' + this.search).then(r => {
        this.users = r.data.data
      })
    },
    async deleteRoleFromUser(item, role) {
      this.loading = true
      await axios.post(baseConfig.basUrlRaw+'api/frontUser/roles/role/delete/user', {
        user_id: item.id,
        role: role
      }).then(r => {
        if (r.data.status === "success")
          this.users = r.data.data
        this.message = {
          status: true,
          text: r.data.message,
          color: r.data.status === "success" ? "success" : "error"
        }
        setTimeout(() => {
          this.message.status = false
        }, 30000)
        this.loading = false
      })
    },
    async setRoleToUser(item) {
      this.loading = true
      await axios.post(baseConfig.basUrlRaw+'api/frontUser/roles/role/set/user', {
        user_id: item.id,
        role: this.$route.params.role
      }).then(r => {
        if (r.data.status === "success")
          this.users = r.data.data
        this.message = {
          status: true,
          text: r.data.message,
          color: r.data.status === "success" ? "success" : "error"
        }
        setTimeout(() => {
          this.message.status = false
        }, 30000)
        this.loading = false
      })
    },
  },
}
</script>
<style scoped>

</style>
